import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { createPricingRoute } from '@wetransfer/transfer/helper/routeFactory';
import I18n from '@wetransfer/transfer/modules/i18n';
import Store from '@wetransfer/transfer/store';

const MobileUpsellBanner = (): JSX.Element => (
  <div className="home__content-block--with-illustration">
    <div className="plus-banner plus-banner--double">
      <div className="plus-banner__header-text">
        <h1 className="plus-banner--double-line">
          {I18n.t('upsell_tiers.mobile.header')}
        </h1>
      </div>
    </div>
    <div className="plus-list">
      <ul>
        <li>{I18n.t('upsell_tiers.mobile.upsell_one')}</li>
        <li>{I18n.t('upsell_tiers.mobile.upsell_enjoy')}</li>
        <li>{I18n.t('upsell_tiers.mobile.upsell_two')}</li>
      </ul>
    </div>
    <a
      id="signup_button"
      href={createPricingRoute('WT202005_home_page_mobile')}
      className="button button--enabled home__content-button"
    >
      {I18n.t('upsell_tiers.mobile.cta')}
    </a>
  </div>
);

const renderHomeUpsellBanner = (): JSX.Element => {
  if (document.querySelector('.home__content-block--with-illustration')) {
    ReactDOM.render(
      <Provider store={Store}>
        <MobileUpsellBanner />
      </Provider>,
      document.querySelector('.home__content-block--with-illustration')
    );
  }

  return null;
};

export default renderHomeUpsellBanner;
